import { ImportableProtocol, Protocol, ProtocolImportDTO, ProtocolUploadDTO } from "../models/Protocol";
import client from "./axios";

const protocolsUrl = `${window.__env.CORE_URL}/protocols`;
const tenantProtocolUrl = `${window.__env.BASE_URL}/protocols`;

export const Protocols = {
  getProtocols: () => client.get<Protocol[]>(protocolsUrl),
  getTenantProtocols: () => client.get<Protocol[]>(tenantProtocolUrl),
  getProtocol: (id: number) => client.get<Protocol>(`${tenantProtocolUrl}/${id}`),
  getImportableProtocols: () => client.get<ImportableProtocol[]>(`${window.__env.BASE_URL}/upload?uploaded=false&type=protocols`),
  createProtocol: (protocol: Protocol) => client.post<Protocol>(protocolsUrl, protocol),
  updateProtocol: (protocol: Protocol) => client.put<Protocol>(`${protocolsUrl}/${protocol.id}`, protocol),
  deleteProtocol: (id: number) => client.delete<Protocol>(`${protocolsUrl}/${id}`),
  deleteTenantProtocol: (id: number) => client.delete<Protocol>(`${tenantProtocolUrl}/${id}`),
  uploadProtocols: (uploadDto: ProtocolUploadDTO) => client.put<ProtocolUploadDTO>(`${window.__env.CORE_URL}/upload`, uploadDto),
  importProtocols: (importProtocols: ProtocolImportDTO[]) => client.put<ProtocolImportDTO[]>(`${window.__env.BASE_URL}/import`, importProtocols)
}